import { useCallback } from 'react';
import connect from 'Shared/connect';
import { addToCart, removeCartItem } from './../../Cart/action-creators';
import { getCartLineItemCountForVariant } from './../../Cart/reducer';
import { getSelectedVariant, getOppositeVariant } from 'Shared/Product/reducer';
import { getStepSize as getQuantityStepSize } from 'Shared/Quantity/utils';
import { selectVariant } from 'Shared/Product/action-creators';
const MiniCartContainer = ({ index, cartItem, quantityInCart, selectedVariant, addToCart, children, removeFromCart, oppositeVariant, selectVariant, }) => {
    const quantityStep = getQuantityStepSize(selectedVariant);
    const url = cartItem.product.url.toString();
    const updateCartQuantity = useCallback((quantity) => {
        const { code, unitShortName, ticket } = selectedVariant;
        // If clicked variant quantity set to 0, and clicked variants opposite still has quantity in the minicart
        if (quantity === 0 && oppositeVariant && oppositeVariant.lineItem.quantity > 0) {
            // Select the clicked variants opposite since it has quantity in the minicart
            selectVariant(oppositeVariant.lineItem.selectedVariant.code);
        }
        return addToCart(code, quantity, unitShortName, ticket);
    }, [selectedVariant, addToCart, cartItem, oppositeVariant, selectVariant]);
    const removeCartItem = useCallback(() => {
        const { code } = selectedVariant;
        return removeFromCart(code);
    }, [selectedVariant, removeFromCart]);
    return children({
        index,
        cartItem,
        removeCartItem,
        quantityInCart,
        selectedVariant,
        updateCartQuantity,
        quantityStep,
        url,
    });
};
export default connect((state, { cartItem }) => {
    const selectedVariant = getSelectedVariant(state, cartItem.product.variants, cartItem.lineItem.selectedVariant);
    const oppositeVariant = getOppositeVariant(state.cart.items, cartItem);
    return {
        selectedVariant,
        oppositeVariant,
        quantityInCart: getCartLineItemCountForVariant(state, selectedVariant),
    };
}, (dispatch, { cartItem }) => {
    return {
        addToCart: (code, quantity, unitShortName, ticket) => dispatch(addToCart(code, quantity, unitShortName, ticket, 'MiniCart')),
        removeFromCart: (code) => dispatch(removeCartItem(code, 'MiniCart')),
        selectVariant: (newVariantCode) => dispatch(selectVariant(newVariantCode, cartItem.product.variants)),
    };
})(MiniCartContainer);
